import { makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { isJourneyVisibleState } from 'pages/CustomerBooking';
import { useMemo } from 'react';
import { useRecoilState } from 'recoil';

export const useStyles = makeStyles((theme) => {
  return {
    header: {
      paddingTop: theme.spacing(5),
      [theme.breakpoints.down("sm")]: {
        paddingTop: theme.spacing(2),
      },
      textAlign: 'center',
    },
    dialog: {
      zIndex: `${theme.zIndex.modal + 1} !important `
    },
    offsetPaper: {
      top: theme.spacing(5),
    },
    offsetScrollBody: {
      verticalAlign: 'top'
    },
    content: {
      textAlign: 'center',
      '&>*': {
        marginBottom: theme.spacing(1),
      }
    },
    preHeader: {
      justifySelf: 'center',
      alignSelf: 'center',
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      justifyContent: 'center',
      "&>*": {
        width: '80%',
        marginBottom: theme.spacing(2)
      },
      paddingBottom: theme.spacing(5),
      [theme.breakpoints.down("sm")]: {
        paddingBottom: theme.spacing(2),
      },
    }
  }
})

const CustomConfirmDialog = ({
  preHeader,
  open,
  onClose = () => { },
  onCancel,
  onConfirm,
  title = "Are you sure?",
  description = "",
  confirmationText = "Ok",
  cancellationText = "Cancel",
  noCancel = false,
  flipButtons = false,
}) => {
  const classes = useStyles()
  const [isJourneyVisible, setIsJourneyVisible]= useRecoilState(isJourneyVisibleState);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"),
  {
    noSsr: true,
  });
  const buttons = useMemo(
    () => {
      const accept = onConfirm &&
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={() => {
            onConfirm && onConfirm();
            onClose && onClose();
          }}
        >
          {confirmationText}
        </Button>

      const cancel = !noCancel &&
        <Button
          fullWidth
          color="default"
          variant="text"
          onClick={() => {
            onCancel && onCancel();
            onClose && onClose();
          }}
        >
          {cancellationText}
        </Button>

      return flipButtons ? [cancel, accept] : [accept, cancel]

    }, [flipButtons, onConfirm, onClose, confirmationText, onCancel, noCancel, cancellationText]
  );

  const renderDescription = useMemo(
    () => {
      return (
        <DialogContent className={classes.content}>
          {description}
        </DialogContent>
      )
    }, [description]
  );
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={() => onClose && onClose()}
      className={classes.dialog}
      classes={{
        paper: classes.dialogRoot,
        paperScrollPaper: isJourneyVisible && classes.offsetPaper,
        paperScrollBody: isJourneyVisible && classes.offsetScrollBody,
      }}
      // fullScreen={isMobile}
      
    >
      {preHeader && (
        <DialogContent className={classes.preHeader}>
          {preHeader}
        </DialogContent>
      )}
      <DialogTitle className={classes.header}><Typography variant="h2">{title}</Typography></DialogTitle>
      {renderDescription}
      <DialogActions className={classes.actions}>
        {buttons}
      </DialogActions>
    </Dialog>
  );
};

export default CustomConfirmDialog;



